var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206 53.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea75ad;}.cls-2{fill:#5d3233;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.68,28.33S142.16,53.08,104.4,53.08,33.32,30.6,33.32,30.6,65.24,0,103,0C138.64,0,172.68,28.33,172.68,28.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,48.52a93.77,93.77,0,0,1,10.8-8.64q5.68-4,11.75-7.37A164.21,164.21,0,0,1,47.89,21,168.78,168.78,0,0,1,103,11l7.07.09c2.35.09,4.7.27,7,.42s4.69.44,7,.73l3.51.44c.58.08,1.17.13,1.75.23l1.73.33,6.93,1.31c2.3.48,4.57,1.12,6.85,1.69l3.4.88,3.36,1.06c2.23.73,4.46,1.44,6.67,2.2A151.35,151.35,0,0,1,206,48.52c-2.16-.83-4.26-1.74-6.38-2.59l-3.13-1.34-1.56-.67-1.59-.61c-2.13-.79-4.22-1.62-6.32-2.44-1.06-.38-2.07-.87-3.14-1.21l-3.19-1.08-6.32-2.22L168,34.44l-3.18-1c-1.06-.3-2.14-.56-3.21-.84-2.15-.55-4.29-1.08-6.41-1.67a237.72,237.72,0,0,0-25.91-4.54c-2.16-.31-4.34-.42-6.51-.63s-4.35-.41-6.53-.45-4.36-.24-6.54-.29h-6.54A238.5,238.5,0,0,0,51,31.46c-8.62,2-17.18,4.46-25.67,7.3S8.39,44.8,0,48.52Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.d2455d35.svg";
export { ForwardRef as ReactComponent };